import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themeFour/f1.png'
import _imports_1 from '@/assets/themeFour/f2.png'


const _hoisted_1 = { class: "mainRow" }
const _hoisted_2 = ["src", "onClick"]

import { goToShare, MediaItem } from '@/view/home/supportScript';
import { ref, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'mediaSection',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const props = __props
const mediaList = ref(props.itemData.shareMediaList)

onMounted(() => {
    mediaList.value = props.itemData.shareMediaList
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "8",
          class: "alignData"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              width: "45%"
            }, null, -1),
            _createElementVNode("img", {
              src: _imports_1,
              alt: "",
              width: "20%"
            }, null, -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "16",
          class: "container"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"margin":"5px"}
              }, [
                (item.display)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.url,
                      alt: "",
                      onClick: ($event: any) => (_unref(goToShare)(item.redirectUrl))
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})